import logo from "@/assets/logo-thailand-elite.png";

export const PortalFooter = () => (
  <footer className="border-t border-border bg-card mt-auto">
    <div className="container mx-auto px-6 py-6 max-w-5xl">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">

        {/* Branding */}
        <div className="flex items-center gap-3">
          <img src={logo} alt="Thailand Elite" className="h-6 opacity-70" />
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <span>Powered by Dreamond</span>
            <span className="text-border">·</span>
            <span>Thailand Privilege GSSA</span>
          </div>
        </div>

        {/* Links */}
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Terms & Conditions
          </a>
          <span className="text-border">·</span>
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            Privacy Policy
          </a>
          <span className="text-border">·</span>
          <span className="text-muted-foreground/60">
            © {new Date().getFullYear()}{" "}
            <a
              href="https://thailand-elite.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Thailand-Elite.com
            </a>
          </span>
        </div>

      </div>
    </div>
  </footer>
);
